import UiMessage from "../../../components/message/Message.component";
import { MessageSeverity } from "../../../models/components/field-message.model";
import { CareMessageClientStatus } from "../../../models/pages/care-messages.model";

const CareMessagesClientState = ({
	clientState,
	loadingConversation,
	loadingMessages,
}: {
	clientState: CareMessageClientStatus;
	loadingConversation: boolean;
	loadingMessages: boolean;
}) => {
	const setMessage = () => {
		let result = "";
		if (
			clientState === CareMessageClientStatus.LOADING ||
			loadingConversation ||
			loadingMessages
		) {
			result = "MESSAGES.LOADING";
		} else if (clientState === CareMessageClientStatus.ERROR) {
			result = "UI_COMPONENTS.MESSAGE.HTTP.ERROR2";
		}
		return result;
	};

	return (
		<div className="messages-state">
			<UiMessage
				severity={
					clientState === CareMessageClientStatus.ERROR
						? MessageSeverity.DANGER
						: MessageSeverity.LOADING
				}
				label={setMessage()}
			/>
		</div>
	);
};
export default CareMessagesClientState;
